import React from "react";
import PropTypes from "prop-types";
import { useIntl } from "react-intl";

import { Paper, withStyles } from "@material-ui/core";
import Truncate from "react-truncate";
import { Flex, Tipografia } from "../../../../_common";

const styles = {
  divEvento: { display: "flex", flexDirection: "column", height: "100%", width: "100%", padding: "8px 8px 0px 8px" },
  tituloCard: { paddingBottom: 5 },
  textoEmails: {
    color: "#457AB7 !important",
    whiteSpace: "nowrap",
    overflow: "hidden",
    textOverflow: "ellipsis",
    width: "75%",
  },
  divLinkVisualizarEmail: { marginTop: "auto", paddingBottom: 3, paddingTop: 3 },
  linkVisualizarEmail: { color: "#457AB7 !important", cursor: "pointer" },
  assunto: { paddingBottom: 5 },
};

const TimeLineItemEmail = ({
  email,
  handleClickVisualizarEmail,
  mostrarEmailHtmlEmTexto,
  isTimelineAtividades,
  classes,
}) => {
  const intl = useIntl();

  return (
    <Paper className={classes.divEvento} zDepth={1} elevation={isTimelineAtividades ? 0 : 1}>
      <Flex className={classes.tituloCard}>
        <Tipografia tipo="notaLegendas" cor="darkSecondaryText">
          {email.headerEmailTexto}&nbsp;
        </Tipografia>
        <Tipografia
          tipo="notaLegendas"
          cor="darkSecondaryText"
          className={classes.textoEmails}
          title={email.headerEmailDePara}
        >
          {email.headerEmailDePara}
        </Tipografia>
      </Flex>

      <Tipografia className={classes.assunto}>{email.assunto}</Tipografia>

      <Tipografia tipo="notaLegendas" cor="darkSecondaryText">
        <Truncate lines={3} ellipsis={<span>...</span>}>
          {mostrarEmailHtmlEmTexto(email.previa)}
        </Truncate>
      </Tipografia>

      {!isTimelineAtividades && (
        <Flex justifyContent="flex-end" className={classes.divLinkVisualizarEmail}>
          <Tipografia tipo="notaLegendas" onClick={handleClickVisualizarEmail} className={classes.linkVisualizarEmail}>
            {intl.formatMessage({ defaultMessage: "Ver e-mail completo" })}
          </Tipografia>
        </Flex>
      )}
    </Paper>
  );
};

TimeLineItemEmail.propTypes = {
  email: PropTypes.object,
  handleClickVisualizarEmail: PropTypes.func,
  mostrarEmailHtmlEmTexto: PropTypes.func,
  classes: PropTypes.object,
  isTimelineAtividades: PropTypes.bool,
};

export default withStyles(styles)(TimeLineItemEmail);
